import { FIND_COMPANY_DEBT_TO_DRIVER } from "./../../routes";
import customAxios from "../../customAxios";
import { IFindUserInformation } from "../../../types/common.interface";
import utils from "../../../utils";

async function findCompanyDebtToDriver(props: IFindUserInformation) {
  var thisUrl = FIND_COMPANY_DEBT_TO_DRIVER;

  let body: any = {
    page: props.page,
    limit: props.limit,
    status: "PENDING",
  };

  if (props?.search?.value) {
    body = {
      ...body,
      search: {
        searchMode: props?.search?.base,
        searchValue: props?.search?.value,
      },
      // [String(props.search.base)]: utils.convertNumbers2English(
      //   props.search.value
      // ),
    };
  }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                                    Filtering For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------
  if (props?.filters) {
    const { province, city, gender, marital } = props.filters;
    body = {
      ...body,
      province: province?._id,
      city: city?._id,
      gender: gender?.value,
      marital: marital?.value,
    };
  }
  // if (city) query({ target: "city", value: city?._id });
  // if (company) query({ target: "company", value: company?._id });
  // if (marital) query({ target: "marital", value: marital?.value });
  // if (gender) query({ target: "gender", value: gender?.value });

  // ?? Academic year (سال تحصیلی) scope, set last so the branches above cannot drop it.
  if (props.academicYear) body.academicYear = props.academicYear;

  try {
    return (
      await customAxios.post(thisUrl, {
        page: props.page,
        limit: props.limit,
        ...body,
      })
    ).data;
  } catch (error: any) {
    console.error({ FIND_COMPANY_DEBT_TO_DRIVER: error });
  }
}

export default findCompanyDebtToDriver;
